import React, { useEffect, useState } from 'react';
import { Lightbulb } from 'lucide-react';
import OptionSheet from './OptionSheet';

interface EscenaPersonalizadaOptionProps {
  open: boolean;
  onClose: () => void;
  value: string;
  onChange: (v: string) => void;
  onAccept: (v: string) => void;
  ideas?: string[];
}

const EscenaPersonalizadaOption: React.FC<EscenaPersonalizadaOptionProps> = ({
  open,
  onClose,
  value,
  onChange,
  onAccept,
  ideas = [],
}) => {
  const [local, setLocal] = useState(value);

  useEffect(() => {
    if (open) setLocal(value);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const content = (
    <>
      {ideas.length > 0 && (
        <div className="mb-4">
          <p className="text-[15px] font-medium text-neutral-700 mb-2">Ideas generadas</p>
          <div className="bg-white border border-neutral-200 rounded-lg overflow-hidden divide-y divide-neutral-100 max-h-48 overflow-y-auto">
            {ideas.map((idea, index) => (
              <button
                key={`${index}-${idea}`}
                type="button"
                onClick={() => setLocal(idea)}
                className="w-full flex items-start gap-3 px-4 py-3 text-left text-[15px] hover:bg-neutral-50"
              >
                <div className="shrink-0 bg-neutral-100 rounded-sm p-1.5">
                  <Lightbulb className="w-4 h-4 text-neutral-600" />
                </div>
                <p className="text-neutral-800 text-[13px]">{idea}</p>
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="flex-1" />

      <div className="bg-white border border-neutral-200 rounded-lg p-4">
        <textarea
          value={local}
          onChange={(e) => setLocal(e.target.value)}
          placeholder="Describí la escena que querés para tus imágenes"
          className="w-full text-[15px] text-neutral-900 resize-none border-none outline-none focus:ring-0 p-0 bg-transparent min-h-[120px]"
        />
      </div>
    </>
  );

  return (
    <OptionSheet
      open={open}
      onClose={() => {
        setLocal(value);
        onClose();
      }}
      onAccept={() => {
        onChange(local);
        onAccept(local);
      }}
      title="Escena personalizada"
      acceptDisabled={!local.trim()}
    >
      {content}
    </OptionSheet>
  );
};

export default EscenaPersonalizadaOption;
